import {createStore, combineReducers} from 'redux';
import admin from './admin/reducer';

export default createStore(
  combineReducers({
    admin
  }),
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);



// WEBPACK FOOTER //
// ./src/store.js